import { getItemFromLocalStorage, setItemFromLocalStorage } from 'reactApp/appHelpers/localstorageHelpers';
import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

export const renderDuplicatesMailSpacePromoModal = () => {
    openPopupHelper({
        popupName: popupNames.DUPLICATES_MAIL_SPACE_PROMO_MODAL,
    });
};

const LOCAL_STORAGE_KEY = 'duplicates-mail-space-promo-modal-show' as const;

export const getDuplicatesMailSpacePromoModalShown = () => getItemFromLocalStorage(LOCAL_STORAGE_KEY);

export const setDuplicatesMailSpacePromoModalShown = () => setItemFromLocalStorage(LOCAL_STORAGE_KEY, true);
